
require([], function() {var a;null!==(a=location.search.match(/[&\?]iwl=([^&]*)/))&&2===a.length&&(/^true$/.test(a[1])?document.cookie="_scc_iwl=1":document.cookie="_scc_iwl=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;")}); 
define("modules/scc-iwl", function(){});
